/**
 * SOJ Core Modern - Main JavaScript Entry Point
 *
 * This file is ready for site-specific JavaScript code.
 * All core functionality is handled by core.js and its modules.
 *
 * @package SOJ_Core_Modern
 * @since 2.0.0
 * @author Son of Jesse
 */

// Import core functionality (this will initialize all modules)
import core from './core.js';
import smoothScroll from './modules/smooth-scroll.js';

// Import utilities if needed for site-specific code
import { utils, events, dom, log } from './modules/utilities.js';

// Import animation systems
import AnimationSystem from './modules/animations.js';
import GSAPAnimationSystem from './modules/gsap-animations.js';

// Import header animation functionality
import { initHeaderScrollBehavior } from './modules/header-animation.js';

// Initialize animation systems
let animationSystem;
let gsapAnimationSystem;

document.addEventListener('DOMContentLoaded', function() {
    // Initialize scroll-triggered animations (CSS-based)
    animationSystem = new AnimationSystem();
    
    // Initialize GSAP animations (load before core's smooth-scroll needs it for Lenis integration)
    gsapAnimationSystem = new GSAPAnimationSystem();
    
    // Make animation systems available globally for dynamic content
    window.SOJ_ANIMATIONS = animationSystem;
    window.SOJ_GSAP_ANIMATIONS = gsapAnimationSystem;
    
    // Connect Lenis smooth scroll with GSAP ScrollTrigger (GSAP loads here, smooth-scroll ran earlier)
    if (smoothScroll?.integrateWithGSAP && typeof gsap !== 'undefined') {
        smoothScroll.integrateWithGSAP();
    }
    
    // Initialize header scroll behavior
    initHeaderScrollBehavior();
    
    console.log('[SOJ] Animation systems loaded (CSS + GSAP)');
});

